import React from 'react';

export default function TableCard({ children }) {
    return (
        <div className="table-rounded-wrapper">
            <div className="table-responsive">
                {children}
            </div>
        </div>
    );
}